export const type = 'form.datePicker';
